import React, { Component } from "react";
import Button from "../../../button-classic/button-classic";
import "../../../route_code/route_code.less";
import "./add-approver-type.less";
import InputText from "../../../../common/components/input-text/input-text";
import ACTIONS from "../../../../common/action_constant";

class AddApproverType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.editData?.name || "",
    };
  }

  onSave = () => {
    const { dispatch, editData, toggleAdd, refreshData, companyId } = this.props;
    const name = this.state.name.trim();
    if (!name) return;

    dispatch({
      type: ACTIONS.PLANTS.ADD_APPROVER_TYPE_MASTER,
      data: {
        name,
        company_id: companyId,
        ...(editData && { id: editData.id ?? editData.approval_type }),
      },
      onSuccess: () => {
        toggleAdd();
        refreshData?.();
      },
    });
  };

  render() {
    const { toggleAdd, editData } = this.props;
    const { name } = this.state;

    return (
      <div className="route_code_detail">
        <div className="overlay" onClick={toggleAdd} />

        <div className="modal-popup approver-type-popup">
          <div className="pop-heading">
            {editData ? "Edit" : "Add"} Approver Type
          </div>

          <div className="route-detail">
            <InputText
              label="Name"
              required
              id="name"
              value={name}
              placeholder="Name"
              changeHandler={(value) => this.setState({ name: value })}
            />

            <div className="button_route">
              <Button value="Cancel" click={toggleAdd} />
              <Button
                value={editData ? "Update" : "Save"}
                disabled={!name.trim()}
                click={this.onSave}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddApproverType;
